import React, { useContext, useEffect } from "react";
import { Card, CardBody } from "reactstrap";
import volunteerStyle from "../../MasterVolunteer/css/volunteer.module.scss";
import { useVolunteerICF } from "modules/Volunteer/ICF/api/useVolunteerICF";
import { BreadcrumbContext } from "../../../../Layouts/Header";
import { VOLUNTEER_PATHS } from "Routes/paths";

interface Props {
  volunteerid: number;
}

const VolunteerICF: React.FC<Props> = ({ volunteerid }) => {
  const { Select } = useVolunteerICF({ volunteerid });

  const icf = Select?.data?.data?.[0];
  const baseUrl = localStorage.getItem("filebaseUrl");
  const pdfUrl = icf ? `${baseUrl}${icf?.path}` : "";

  const breadcrumbContext = useContext(BreadcrumbContext);
  const setBreadcrumbItems = breadcrumbContext?.setBreadcrumbItems;

  useEffect(() => {
    setBreadcrumbItems?.([
      { text: "Volunteers", link: VOLUNTEER_PATHS.LIST },
      { text: "RCF Document" },
    ]);

    return () => {
      setBreadcrumbItems?.([]);
    };
  }, []);

  /* ================= SKELETON ================= */

  if (Select.isLoading || Select.isFetching) {
    return (
      <Card
        className={`shadow-sm border-0 mb-0 ${volunteerStyle.pdf_viewer_wrapper_volunteer_icf}`}
        style={{ borderRadius: "16px", overflow: "hidden" }}
      >
        {/* HEADER SKELETON */}
        <div className="px-3 py-2 border-bottom bg-light d-flex align-items-center gap-2 placeholder-glow">
          <div className="placeholder rounded-circle" style={{ width: "24px", height: "24px", color: "#ced4da" }} />
          <div className="placeholder col-3" style={{ color: "#ced4da" }} />
        </div>

        {/* PDF SKELETON */}
        <CardBody className="p-0 placeholder-glow h-100">
          <div className="placeholder w-100" style={{ height: "600px", color: "#ced4da" }} />
        </CardBody>
      </Card>
    );
  }

  /* ================= EMPTY STATE ================= */

  if (!pdfUrl) {
    return (
      <Card
        className={`${volunteerStyle.pdf_viewer_wrapper_no_volunteer_icf} border-0 shadow-sm mb-0`}
        style={{ borderRadius: "16px" }}
      >
        <CardBody className="d-flex flex-column align-items-center justify-content-center text-center p-5">
          <div
            className="d-flex align-items-center justify-content-center mb-4"
            style={{
              width: "70px",
              height: "70px",
              borderRadius: "50%",
              background: "#f1f3f5",
            }}
          >
            <i
              className="ri-file-search-line"
              style={{ fontSize: "2rem", color: "#868e96" }}
            ></i>
          </div>

          <h5 className="fw-semibold text-dark mb-2">
            No RCF Document Available
          </h5>

          <p className="text-muted mb-0" style={{ maxWidth: "300px" }}>
            The informed consent form for this volunteer has not been uploaded yet.
          </p>
        </CardBody>
      </Card>
    );
  }

  /* ================= PDF VIEW ================= */

  return (
    <Card
      className={`shadow-sm border-0 mb-0 ${volunteerStyle.pdf_viewer_wrapper_volunteer_icf}`}
      style={{ borderRadius: "16px", overflow: "hidden" }}
    >
      {/* HEADER */}
      <div className="d-flex align-items-center justify-content-between px-3 py-2 border-bottom bg-light">
        <div className="d-flex align-items-center gap-2">
          <i className="ri-file-pdf-line text-danger fs-5"></i>
          <span className="fw-semibold">RCF Document</span>
        </div>
      </div>

      {/* PDF */}
      <iframe
        src={pdfUrl}
        style={{
          height: "600px",
          width: "100%",
          border: "none",
        }}
        title="ICF Document"
      />
    </Card>
  );
};

export default VolunteerICF;